import { DurabilityIncidenceType } from '../../../../types';
export var list = [
    DurabilityIncidenceType.GREENHOUSE_GAS,
    DurabilityIncidenceType.BIODIVERSITY,
    DurabilityIncidenceType.WATER,
    DurabilityIncidenceType.TRASH,
    DurabilityIncidenceType.SOCIAL_AND_PERSON,
];
